export const PERSISTENT_KEY_AUTH_USER = 'user';
export const PERSISTENT_KEY_ACCESS_TOKEN = 'accessToken';
export const PERSISTENT_KEY_REFRESH_TOKEN = 'refreshToken';
export const PERSISTENT_KEY_VIEW = 'listLayout';
export const PERSISTENT_KEY_MY_PARTICIPANTS_TOUR_PROMPT = 'myParticipantsTourPromptAnswered';
export const PERSISTENT_KEY_ADMIN_PARTICIPANTS_TOUR_PROMPT = 'adminParticipantsTourPromptAnswered';
